import {
  Component,
  ChangeDetectionStrategy,
  inject,
  computed,
} from "@angular/core";
import { DashboardStateService } from "@app/services/dashboard-state.service";
import {
  KnittingOrder,
  PerformanceMetrics,
} from "@app/models/dashboard.models";
import { staggerSlideIn } from "@app/animations/stagger-entrance.animation";

const DISPLAY_LIMIT = 6;

@Component({
  selector: "app-knitting-order-progress",
  templateUrl: "./knitting-order-progress.component.html",
  styleUrl: "./knitting-order-progress.component.scss",
  animations: [staggerSlideIn],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class KnittingOrderProgressComponent {
  private readonly stateService = inject(DashboardStateService);

  readonly orders = computed<KnittingOrder[]>(
    () =>
      this.stateService.lastData()?.knittingOrders?.slice(0, DISPLAY_LIMIT) ??
      [],
  );

  readonly metrics = computed<PerformanceMetrics | null>(
    () => this.stateService.lastData()?.performanceMetrics ?? null,
  );

  readonly animationTrigger = computed(() => this.orders());
}
